<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>Ändra film {{$route.params.id}}</v-toolbar-title>
    </v-toolbar>
    <v-autocomplete
      v-model="select"
      :loading="loading"
      :items="items"
      :search-input.sync="search"
      cache-items
      class="mx-4"
      flat
      hide-no-data
      hide-details
      item-text="description"
      item-value="id"
      label="Sök film"
      solo-inverted
      return-object
    ></v-autocomplete>
    <template slot="selection" slot-scope="data">
      {{ data.item.description }}
    </template>
    <v-text-field
      label="Titel"
      :rules="[required]"
      v-model="movie.title"
    ></v-text-field>
    <v-text-field
      label="Genre"
      v-model="movie.genre"
    ></v-text-field>
    <v-text-field
      label="Poster"
      v-model="movie.moviePoster"
    ></v-text-field>
    <img class="movie-poster" :src="movie.moviePoster" />
    <v-text-field
      label="Land"
      v-model="movie.country"
    ></v-text-field>
    <v-text-field
      label="År"
      :rules="[required]"
      v-model="movie.year"
    ></v-text-field>
    <v-text-field
      label="Handling"
      v-model="movie.plot"
    ></v-text-field>
    <v-text-field
      label="Datum för filmklubb"
      v-model="movie.viewDate"
    ></v-text-field>
    <v-text-field
      label="Längd"
      v-model="movie.runtime"
    ></v-text-field>
    <v-text-field
      label="Betyg IMDb"
      v-model="movie.imdbRating"
    ></v-text-field>
    <v-select
      v-model="movie.chosenBy"
      :items="chooserItems"
      label="Vald av"
      :rules="[required]"
    ></v-select>
    <v-text-field
      label="Betyg Lisa"
      :rules="[required]"
      v-model="movie.lRating"
      v-on:change="calcAverageRating()"
    ></v-text-field>
    <v-text-field
      label="Betyg Erik"
      :rules="[required]"
      v-model="movie.eRating"
      v-on:change="calcAverageRating()"
    ></v-text-field>
    <v-text-field
      label="Betyg Johan"
      :rules="[required]"
      v-model="movie.jRating"
      v-on:change="calcAverageRating()"
    ></v-text-field>
    <v-text-field
      label="Betyg Kerstin"
      :rules="[required]"
      v-model="movie.kRating"
      v-on:change="calcAverageRating()"
    ></v-text-field>
    <v-text-field
      label="Snitt" disabled
      v-model="movie.avgRating"
    ></v-text-field>
    <v-text-field
      label="Kommentar Lisa"
      v-model="movie.lComment"
    ></v-text-field>
    <v-text-field
      label="Kommentar Erik"
      v-model="movie.eComment"
    ></v-text-field>
    <v-text-field
      label="Kommentar Johan"
      v-model="movie.jComment"
    ></v-text-field>
    <v-text-field
      label="Kommentar Kerstin"
      v-model="movie.kComment"
    ></v-text-field>
    <div class="error" v-if="error">
      {{error}}
    </div>
    <v-btn @click="update">Uppdatera</v-btn>
  </v-container>
</template>

<script>
import MovieService from '@/services/movies_service'
export default {
  data () {
    return {
      movie: this.$route.params,
      loading: false,
      items: [],
      chooserItems: [ 'Erik', 'Johan', 'Kerstin', 'Lisa', 'Okänd' ],
      search: null,
      select: null,
      error: null,
      required: (value) => !!value || 'Required'
    }
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    },
    select (val) {
      this.doFetch(val.id)
    }
  },
  methods: {
    async update () {
      this.error = null
      try {
        await MovieService.edit(this.movie)
        this.$router.push({
          name: 'movies'
        })
      } catch (err) {
        this.error = err
      }
    },
    calcAverageRating: function () {
      this.movie.avgRating = (parseInt(this.movie.eRating) + parseInt(this.movie.jRating) + parseInt(this.movie.kRating) + parseInt(this.movie.lRating)) / 4
    },
    querySelections (v) {
      this.loading = true
      setTimeout(() => {
        this.doSearch(v)
        this.loading = false
      }, 1000)
    },
    async doSearch (s) {
      const response = await fetch('https://www.omdbapi.com/?apikey=6211a6b9&type=movie&s=' + s)
      const data = await response.json()
      if (data.Response === 'True') {
        this.items = []
        for (var i = 0; i < data.Search.length; i++) {
          var obj = {
            description: data.Search[i].Title + ' - ' + data.Search[i].Year,
            id: data.Search[i].imdbID
          }
          this.items[i] = obj
        }
      }
    },
    async doFetch (i) {
      const response = await fetch('https://www.omdbapi.com/?apikey=6211a6b9&i=' + i)
      const data = await response.json()
      this.movie.title = data.Title
      this.movie.genre = data.Genre
      this.movie.moviePoster = data.Poster
      this.movie.country = data.Country
      this.movie.year = new Date(data.Released).getUTCFullYear()
      this.movie.plot = data.Plot
      this.movie.runtime = data.Runtime
      this.movie.imdbRating = data.imdbRating
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EditMovie.vue